import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=78a2f1ca&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"
import style0 from "./Test2.vue?vue&type=style&index=0&id=78a2f1ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2f1ca",
  null
  
)

export default component.exports